import React from 'react';
import { CenterScreenComponent, Link, StatusBadge } from '../../components';
import { useMeQuery, useModerationDashboardQuery } from '../../generated/graphql';
import routes from '../../routes/routes';

interface ModerationScreenProps {}

export const ModerationScreen: React.FC<ModerationScreenProps> = ({}) => {
    return null;
};
